import { useClient, useMutation } from '@weenat/client'
import { getErrorMessage } from '@weenat/client/dist/errors'
import { useIntl } from '@weenat/wintl'
import logEvent from 'app/utils/analytics'
import React from 'react'
import useDisclosure from '../hooks/useDisclosure'
import useToasts from '../hooks/useToasts'
import Button from '../kit/Button'
import { ControlledModalOverlay } from '../kit/ModalOverlay'
import Text from '../kit/Text'

const AskForMoreVWS: React.FC<Pick<ReturnType<typeof useDisclosure>, 'close' | 'isOpen'>> = ({
  close,
  isOpen
}) => {
  const { t } = useIntl()
  const client = useClient()
  const { addSuccessToast, addErrorToast } = useToasts()
  const [askForMoreVWS, askForMoreVWSState] = useMutation(client.devices.askForMore(), {
    onError: (e) => {
      addErrorToast(getErrorMessage({ error: e, t }))
    },
    onSuccess: () => addSuccessToast(t('actions.ask_for_more_vws'))
  })

  return (
    <ControlledModalOverlay isOpen={isOpen} close={close}>
      <Flex
        $flexDirection='column'
        $alignItems='center'
        $gap='xl'
        $backgroundColor='primary.500'
        $borderRadius='lg'
        $p='lg'
        $width={440}
        $borderColor={'alpha.black.30'}
      >
        <Text $color='grayscale.white' $fontWeight='bold'>
          {t('models.vws.ask_for_more_modal.title')}
        </Text>
        <Text $textAlign='center' $color='grayscale.white'>
          {t('models.vws.ask_for_more_modal.description')}
        </Text>
        <Button
          backgroundColor='grayscale.white'
          onPress={async () => {
            try {
              await askForMoreVWS()
              logEvent('vws_callmeback')
              close()
            } catch {}
          }}
          color='primary.500'
          isLoading={askForMoreVWSState.isPending}
        >
          {t('models.vws.ask_for_more_modal.CTA')}
        </Button>
      </Flex>
    </ControlledModalOverlay>
  )
}

export default AskForMoreVWS
